import i18next from 'i18next';

import { CLAIM, PROCEDURE } from '../../../constants/userForms';

i18next.addResources('es', 'EdenCommons', {
  accept: 'Aceptar',
  cancel: 'Cancelar',
  back: 'Volver',
  close: 'Cerrar',
  email: 'Email',
  type: 'Tipo',
  status: 'Estado',
  address: 'Dirección',
  confirm: 'Confirmar',
  return: 'Volver',
  clientNumber: 'NIS',
  selectAll: 'Seleccionar todo',
  of: 'de',
  office: 'Sede',
  reload: 'Recargar',
  reference: 'Referencias',
  enabled: 'Disponible',
  disabled: 'No disponible',
  selected: 'Seleccionado',
  procedure: 'Trámite',
  send: 'Enviar'
});

i18next.addResources('es', 'EdenServiceAdherence', {
  digitalBillAdherence: 'Adhesión a factura digital'
});

i18next.addResources('es', 'EdenDefaultMessages', {
  // Account actions
  addAccountSuccess: 'El suministro fue registrado exitosamente.',
  addAccountFailure: 'No se pudo registrar tu suministro en este momento. Por favor intentá más tarde.',
  addAccountsSuccess: 'El suministro fue registrado exitosamente.',
  addAccountsFailure: 'No se pudo registrar tu suministro en este momento. Por favor intentá más tarde.',
  getAccountAsyncFailure: 'Hubo un error al recuperar tu estado de cuenta.',
  deleteAccountSuccess: 'El suministro fue desvinculado exitosamente.',
  deleteAccountFailure: 'El suministro no pudo desvincularse en este momento, por favor intentá más tarde.',
  getQuestionsFailure: 'Hubo un problema al solicitar la información.',
  getRelatedAccountsFailure: 'Hubo un error al recuperar los suministros relacionados',
  getTermsAndConditionsFailure:
    'Hubo un error al recuperar los términos y condiciones, por favor intente nuevamente mas tarde.',
  validateSocialRateFailure:
    'Hubo un problema al procesar tu consulta, por favor intentá nuevamente más tarde.',
  getAccountBalanceFailure:
    'Hubo un error al recuperar el saldo de tu suministro, por favor reintentá más tarde.',
  getTermsOfServiceFailure:
    'Hubo un error al recuperar los terminos y condiciones, por favor intentá nuevamente más tarde.',
  acceptServiceAgreementSuccess: 'La adhesión al servicio se ha realizado exitosamente.',
  acceptServiceAgreementFailure:
    'Hubo un error al procesar tu solicitud, por favor intentá nuevamente más tarde.',

  evaluateChangeExpirationDateFailure:
    'Hubo un error al recuperar la información de tus fechas de vencimiento actuales, por favor intentá nuevamente más tarde',
  changeExpirationDateFailure:
    'Hubo un error al actualizar tu fecha de vencimiento. Por favor intentá nuevamente más tarde',
  changeExpirationDateSuccess: 'La fecha de vencimiento fue actualizada exitosamente',
  positiveCreditStatusFailure:
    'Hubo un error al procesar tu solicitud, por favor intentá nuevamente más tarde.',
  getAccountsInfoFailure: 'Hubo un error al recuperar sus cuentas.',
  // Auth actions
  signInFailure: 'No se pudo iniciar sesión, el servicio no está disponible en este momento.',
  signUpFailure: 'No se pudo crear el usuario, el servicio no está disponible en este momento.',
  changePrimaryEmailFailure: 'Hubo un error al enviarle el código para validar el email',
  changePrimaryEmailSuccess: 'Se ha enviado un código a su email para validarlo',
  validateChangeEmailFailure: 'Hubo un error al validar el código enviado a su email',
  validateChangeEmailSuccess: 'Su email ha sido modificado correctamente',
  validateEmailFailure: 'Hubo un error al validar tu email. Por favor intentá nuevamente más tarde',
  resendVerificationCodeSuccess:
    'El código fue reenviado a tu email. Si no ves el correo en tu bandeja de entrada, revisá la carpeta de correo no deseado.',
  resendVerificationCodeFailure: 'No se pudo iniciar sesión, el servicio no está disponible en este momento.',
  newPasswordRequestSuccess:
    'En instantes recibirás un Email para cambiar tu contraseña. Si no ves el correo en tu bandeja de entrada, revisá la carpeta de correo no deseado.',
  newPasswordRequestFailure:
    'No se pudo recuperar la contraseña, el servicio no está disponible en este momento',
  changePasswordSuccess: 'Se ha cambiado la contraseña correctamente.',
  changePasswordFailure: 'No se ha podido cambiar la contraseña. Revise su conexión de internet.',
  samePasswords: 'La nueva contraseña no puede ser igual a la actual.',
  authInvalidNewPasswords: 'Las contraseñas ingresadas deben coincidir.',
  tokenError: 'Ya se ha usado este link, por favor solicite uno nuevo',
  recoveryPasswordSuccess: 'Se ha cambiado la contraseña correctamente.',
  recoveryPasswordFailure: 'No se ha podido cambiar la contraseña. Revise su conexión de internet.',
  getIdentityValidationFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  validateIdentityAnswersFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  getUserInformationFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  getUserProfileFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  updateUserProfileFailure:
    'Hubo un error al actualizar su información, por favor intente nuevamente más tarde.',
  updateUserProfileSuccess: 'La información fue actualizada exitosamente.',
  getUserIdentificationFailure:
    'Hubo un problema al verificar tus datos, por favor intenta nuevamente más tarde.',

  // Bill actions
  getBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getCurrentBillFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getPrintedBillFailure: 'Hubo un error al descargar tu factura.',
  getLastBillFailure: 'Hubo un error al recuperar tu factura. Intentá más tarde.',
  getBillProgressFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getConsumptionHistoryFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  appendBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getPublicPaymentDocumentFailure: 'El suministro no registra liquidaciones emitidas pendientes de pago.',
  getLastBillInformationFailure:
    'Hubo un error al recuperar la información de tu última factura, por favor reintenta más tarde',
  getMultipleBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',

  // Custom Procedures actions
  evaluateAccountHolderChangeFailure: 'Hubo un error intente nuevamente mas tarde.',
  getAccountDataFailure: 'Hubo un error intente nuevamente mas tarde.',
  createHolderChangeFailure: 'Hubo un error intente nuevamente mas tarde.',
  getAccountProceduresFailure: 'Hubo un error intente nuevamente mas tarde.',
  evaluateTerminationRequestFailure: 'Hubo un error intente nuevamente mas tarde.',
  cancelCustomProcedureSuccess: 'Se ha cancelado el trámite correctamente',
  cancelCustomProcedureFailure: 'Hubo un error intente nuevamente mas tarde.',
  entitiesLoginFailure: 'Hubo un error al iniciar sesión',

  // Notificaction actions
  getUserNotificationsFailure: 'Hubo un error en la busqueda de sus notificaciones.',
  appendNotificationsFailure: 'Hubo un error intente nuevamente mas tarde.',
  setNotificationsSeenFailure: 'Hubo un error intente nuevamente mas tarde.',
  setNotificationAsReadFailure: 'Hubo un error intente nuevamente mas tarde.',

  // Payment actions
  getPaymentDocumentFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getAccountUnpaidFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getUserUnpaidBillsFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getPayableDocumentsFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getPaymentTokenFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',
  paymentRequestFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',
  getPaymentIdentifierFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',

  // Point actions
  getPointsDetailFailure: 'Tus puntos no pudieron ser recuperados, por favor intenta más tarde.',
  appendPointsTransactionsFailure: 'Tus puntos no pudieron ser recuperados, por favor intenta más tarde.',

  // Tip actions
  getEnergyTipsFailure: 'Hubo un error al conseguir los consejos. Intentá más tarde.',
  tipToggleLike: 'Hubo un error al querer ponerle like. Intentá más tarde.',

  // User Form actions
  getFormResponsesFailure: 'Hubo un error intente nuevamente mas tarde.',
  appendFormResponsesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormCategoriesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getPublicFormCategoriesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormResponseDetailsFailure: 'Hubo un error intente mas tarde.',
  submitFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  claimSubmitSuccess: 'El reclamo se creó correctamente.',
  procedureSubmitSuccess: 'El trámite se creó correctamente.',
  procedureSurveySubmitSuccess: '¡Muchas gracias!',
  paymentSurveySubmitSuccess: '¡Muchas gracias!',
  submitPublicFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  reiterationFailure: 'No se pudo reiterar el trámite.',
  reiterationSuccess: 'El trámite fue reiterado satisfactoriamente.',
  cancelationFailure: 'No se pudo cancelar el trámite.',
  cancelationSuccess: 'El trámite fue cancelado satisfactoriamente.',

  // Vouchers actions
  getVouchersInfoFailure: 'Hubo un error al recuperar los vouchers',
  voucherExchangeFailure: 'No es posible efectuar el canje.',

  // Forms
  uploadFileError: 'Se produjo un error al subir tu archivo.',

  // Turns
  getFormsFailure: 'Hubo un error al recuperar los tramites.',
  getOfficesFailure: 'Hubo un error al recuperar las oficinas disponibles.',
  getUserTurnsFailure: 'Hubo un error al recuperar los turnos. Probá intentando de nuevo más tarde.',
  getOfficeDaysFailure: 'Hubo un error al recuperar los días disponibles.',
  getOfficeSlotFailure: 'Hubo un error al recuperar los horarios de la oficina.',
  createNewTurnSuccess: 'Su turno fue creado con exito.',
  createNewTurnFailure: 'Hubo un error al crear el turno. Probá intentando de nuevo más tarde.',
  cancelationTurnSuccess: 'Su tramite fue cancelado con exito.',
  cancelationTurnFailure: 'Hubo un error al cancelar el turno. Probá intentando de nuevo más tarde.',
  updateTurnSuccess: 'Su turno fue actualizado con exito.',
  updateTurnFailure: 'Hubo un error al actualizar su turno. Probá intentando de nuevo más tarde.'
});

i18next.addResources('es', 'EdenErrorScreen', {
  error: 'Ops!',
  noElements: 'Nada por aquí!',
  timer: 'Espere...',
  noItemsError: 'No se encontraron resultados',
  userWithoutAccounts:
    'Ud. no posee Suministros asociados a su Cuenta. En caso de querer solicitar un nuevo Servicio deberá dirigirse a una sucursal comercial o, si la propiedad ya posee uno, efectuar el Cambio de Titularidad desde el menú Trámites.'
});

i18next.addResources('es', 'EdenTurns', {
  myTurns: 'Mis turnos',
  requestTurn: 'Solicitar turno',
  requestTurnTitle: 'Buscá y solicitá tu turno en línea',
  requestTurnSubtitle: 'Solicitá un nuevo turno para realizar tus gestiones desde ahí',
  nextTurns: 'Próximos turnos',
  withoutTurnsTitle: 'No tenés turnos próximos',
  withoutTurnsSubtitle: 'Buscá y solicitá un turno en línea.',
  confirmatedTurnSubtitle: ' presiona la opcion que deseas modificar',
  newTurnTitle: 'Solicitá tu turno online',
  selectOffice: 'Seleccioná la oficina',
  selectDate: 'Seleccioná la fecha',
  selectTime: 'Seleccioná el horario',
  titleErrorCard: 'Ups! Hubo un problema',
  buttonErrorCard: 'Recargar Formulario',
  confirmatedTurn: 'Confirmá tu turno',
  confirmatedTurnTitle: ' Detalles del turno seleccionado',
  cancelationTurnTitle: 'Cancelación de turno',
  cancelationTurnContent: '¿Seguro que quiere cancelar el turno?',
  officesIsEmpty: 'No se encontraron oficinas para generar su turno.',
  selectFormTitle: 'Seleccioná el trámite a realizar',
  selectFormPlaceHolder: 'Seleccionar tramite',
  selectFormAlertInfo:
    'Recordá que podés hacer este trámite de <br/> <br/> manera online a través de nuestra oficina virtual',
  confirmatedTurnModal: 'Turno confirmado',
  presentationRequirementsTitle: 'Recordá que es requisito presentarte con la siguiente información:',
  presentationRequirements: '[Requisitos de presentación]({{presentationRequirementsURL}})',
  modalFormAlertInfo:
    'Recordá que podés hacer este trámite de manera online a través de nuestra oficina virtual',
  calendarInfo: 'El calendario habilitará sólo los días con turnos disponibles.',
  withoutSlots: 'No hay turnos disponibles',
  contactInformation: 'Datos de contacto',
  updateUserInformation:
    'Los datos ingresados actualmente no los tenés en tu perfil de usuario, te sugerimos actualizarlos para próximas comunicaciones',
  calendarWarning: 'Recordá que no se puede pedir turno para el mismo día.'
});

i18next.addResources('es', 'EdenUTFileInput', {
  selectFile: 'Seleccionar archivo'
});

i18next.addResources('es', 'EdenMaps', {
  locationDisabled:
    'La ubicación se encuentra desactivada, por favor habilitarla desde la configuración de su navegador.',
  locationError: 'No pudimos determinar tu ubicación.',
  locationSearching: 'Estamos recuperando tu ubicación...',
  searchPlaceholder: 'Ingresá una dirección',
  invalidConfig:
    'No se encuentran configuradas en el field las keys a utilizar para alguno de los siguientes campos: latitude, longitude y/o formatted_address'
});

i18next.addResources('es', 'EdenPhoneInput', {
  areaCodeLabel: 'Cod. área',
  areaCodePlaceholder: 'Sin 0',
  phoneNumber: 'Número de teléfono',
  codeWithZero: 'Ingrese el código sin 0',
  invalidCode: 'Código de área invalido',
  phoneWithZero: 'El número no debe tener 0',
  phoneWithFifteen: 'El número no debe tener 15'
});

i18next.addResources('es', 'EdenValidations', {
  required: 'Campo obligatorio',
  invalidFormat: 'Formato inválido',
  invalidCard: 'La tarjeta ingresada no es válida',
  invalidEmail: 'El email ingresado no es válido',
  invalidCardExpDate: 'La fecha de vencimiento de la tarjeta es inválida',
  minThreeDigits: 'Debe ingresar 3 dígitos.',
  minSixDigits: 'Debe ingresar 6 dígitos.',
  maxDate: 'La fecha debe ser menor o igual a {{date}}.',
  minDate: 'La fecha debe ser mayor a {{date}}',
  dateIsAfterActualDate: 'La fecha no puede ser posterior a la actual',
  logicValidationMessage: 'El campo no cumple con la validación.',
  passwordRequireLetterAndNumber: 'La contraseña debe contener números y letras',
  cardNumberRequired: 'Campo obligatorio',
  invalidCardNumber: 'El número de tarjeta es inválido',
  holderNameRequired: 'Campo obligatorio',
  expiresRequired: 'Campo obligatorio',
  invalidExpires: 'La fecha de vencimiento es inválida',
  securityCodeRequired: 'Campo obligatorio',
  maxFourDigits: 'Debe ingresar solamente 4 dígitos',
  passwordSameValue: 'Las contraseñas ingresadas deben coincidir.'
});

i18next.addResources('es', 'EdenFormCreator', {
  claimInit: 'Nuevo reclamo',
  claimCategories: 'Tipo de reclamo',
  procedureInit: 'Nuevo trámite',
  procedureSurveyInit: 'Encuesta de tramite',
  paymentSurveyInit: 'Encuesta de pago  ',
  procedureCategories: 'Tipo de trámite',
  procedureInitError: 'Hubo un error al iniciar el trámite.',
  claimInitError: 'Hubo un error al iniciar el reclamo.',
  complaintInitError: 'Hubo un error al iniciar la denuncia.',
  submitSuccess: 'Tu pedido se registró satisfatoriamente.',
  loading: 'Cargando',
  goToProcedure: 'Ir al trámite',
  defaultAlertModalTitle: 'Información',
  uploadFileError: 'Se produjo un error al subir tu archivo.'
});

i18next.addResources('es', 'EdenRegisterAccount', {
  supply: 'NIS',
  supplyAddress: 'Dirección del suministro registrado',
  accountHolderChangeTitle: 'Dar de alta una cuenta',
  accountHolderChangeSubtitle: 'Aquí podrás dar de alta una cuenta',
  continue: 'Continuar',
  finishedProcedure:
    'El trámite finalizo correctamente. Debe identificar el habitáculo del medidor, pegando en el mismo un cartel con el número de suministro.',
  checkLabel:
    'Declaro haber leído y conocer el Reglamento de Suministro Vigente (para consultar el Reglamento de Suministro Vigente [ingrese aquí]({{regulationURL}}))',
  userDataLabel:
    'Los datos ingresados en la presente tendrán carácter de declaración jurada y en cumplimiento a lo indicado en el artículo 6 de la Ley 25326.',
  userDebtCancel:
    'Es necesario que canceles la deuda existente asociada a este suministro para finalizar el trámite.',
  clientDebt: 'Cargos a abonar del suministro {{supply}}',
  ownDebt: 'Cargos a abonar del usuario {{holder}}',
  createProcedure: 'Ingresar solicitud',
  accountDebtDescription:
    'La deuda a abonar incluye la totalidad de las facturas impagas, el cálculo de consumo a la fecha y todo otro concepto que se encuentre pendiente (intereses por mora, gastos administrativos, devolución de depósito en garantía u otros conceptos)',
  cancel: 'Cancelar',
  payDebt: 'Pagar deuda',
  procedureHistory: 'Historial del trámite',
  userDebt: 'Deuda total: {{debt}}',
  supplyError:
    'El Suministro ingresado no puede ser dado de a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas',
  cancelSuccess: 'Se ha cancelado el trámite correctamente',
  nextBillCharge: 'Cargos a incluir en su próxima factura',
  nextBillChargeContent:
    'Tasa de conexión: Dentro de las condiciones generales de habilitación del servicio, el usuario debe abonar el Cargo de Conexión de acuerdo al Cuadro Tarifario Vigente',
  wrongAccount: 'Nro de Suministro Inexistente',
  warrantyCharge: 'Depósito en garantía: {{amount}}',
  holderChangePending:
    'La presente solicitud sobre el suministro seleccionado se encuentra en curso. En la siguiente pantalla podés visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma',
  commercialHolderChangeError:
    'Por el momento, un Suministro con destino Comercial no puede ser dado de alta a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  othersHolderChangeError:
    'Por el momento, un Suministro con destino Consorcio, obra y otros no puede ser dado de alta a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  clientNumberInput: 'Ingresá los {{accountLength}} dígitos del NIS',
  select: 'Seleccioná uno de tu suministros',
  enterNIS: 'O ingresá uno que no tengas asociado'
});

i18next.addResources('es', 'EdenConfiguration', {
  basicInformation: 'Información básica',
  user: 'Usuario',
  changePassword: 'Cambiar Contraseña',
  userInformation: 'Teléfonos',
  invalidCurrentPassword: 'La contraseña actual es incorrecta.',
  notifications: 'Notificaciones',

  configurationSummary: 'Configuración',
  configuration: 'Configuración',
  change: 'CAMBIAR',
  close: '',
  configurationLabel: ``,
  notificationsSettingDescription: `Elige si querés recibir notificaciones sobre vencimientos, disponibilidad de facturas o problemas en tu zona.`,
  typeCurrentPassword: 'Contraseña actual',
  typeNewPassword: 'Contraseña nueva',
  confirmNewPassword: 'Volvé a escribir tu contraseña nueva',
  phone: 'Ingresá un número de teléfono',
  phoneWithoutZero: 'Nro de teléfono (sin 0 y sin 15)',
  mobile: 'Celular',
  save: 'Aceptar',
  yes: 'Si',
  no: 'No',
  primaryPhone: 'Teléfono primario',
  phonesTitle: '',
  emailsTitle: 'Direcciones de email',
  passwordPlaceholder: 'Ingresá tu contraseña',
  changeEmailModalContent: 'El email ingresado será tomado como su nuevo email primario.',
  changePrimaryEmailTitle: 'Cambio de email',
  changeEmailPlaceholder: 'Ingrese su email',
  validateCodePlaceholder: 'Ingrese el código de 4 digitos.',
  saveButton: 'Aceptar',
  userInfoSubmitError: 'Por favor, verifique los datos ingresados.',
  phoneIsRequired: 'Al menos un télefono es requerido',
  carrier: 'Compañia'
});

i18next.addResources('es', 'EdenChangeUserInfo', {
  title: 'Teléfonos',
  warningMessage: 'Para poder operar usted deberá actualizar sus datos personales.',
  withoutData: 'Sin datos'
});

i18next.addResources('es', 'EdenFieldDetails', {
  reiterate: 'Reiterar',
  pending: 'En curso',
  cancelled: 'Cancelado',
  cancelled2: 'Cancelada',
  rejected: 'Rechazado',
  completed: 'Completado',
  completionAt: 'Fecha de completitud',
  expectedCompletionAt: 'Fecha estimada de completitud',
  [PROCEDURE]: 'Trámites',
  [CLAIM]: 'Reclamos',
  cancelPlaceholder: 'Ingrese el motivo de su cancelación',
  reiterationPlaceholder: 'Ingrese un comentario.. ',
  fieldRequired: 'Campo obligatorio'
});

i18next.addResources('es', 'EdenSidebar', {
  invoicesAndPayments: 'Mis facturas',
  technicalService: 'Reclamos Técnicos',
  accountStatus: 'Mi Suministro',
  customerSupport: 'Trámites',
  energyAdvisor: 'Consejos',
  newClaim: 'Reclamos Técnicos',
  claims: 'Consulta de estado de reclamos',
  newProcedure: 'Consulta comercial',
  procedures: 'Consulta de estado de trámites',
  complaints: 'Denuncias de conexiones clandestinas',
  altSidebarButton: 'Botón de Sidebar',
  altArrowButton: 'Botón desplegable',
  chatbox: 'Agente virtual',
  invoicesList: 'Mis facturas',
  documentsAndPayments: 'Cupones y pagos',
  paymentDocuments: 'Cupón de pago',
  payments: 'Pagá tu factura',
  points: 'Tus puntos',
  settings: 'Configuración',
  socialRate: 'Tarifa social',
  lastBillQuery: 'Importe y vencimiento',
  balanceQuery: 'Consulta de saldo',
  accountHolderChange: 'Cambio de titularidad',
  terminationRequest: 'Dar de baja el servicio',
  changeDueDate: 'Jubilados y Pensionados',
  registerAccount: 'Dar de alta una cuenta',
  simulatorButton: 'Simulador de consumo',
  consultDepositWarranty: 'Consulta depósito en garantía',
  consultFineQuality: 'Consulta multas de calidad',
  myTurns: 'Mis turnos'
});

i18next.addResources('es', 'EdenNotification', {
  withoutNotifications: 'Usted no posee ninguna notificación.'
});

i18next.addResources('es', 'EdenAccountDetails', {
  digitalBill: 'Factura digital',
  automaticDebit: 'Débito automático',
  mainCustomer: 'Usuario principal',
  notMainCustomer: 'No es el usuario principal del suministro',
  detail: 'Detalle',
  subscribed: 'Adherido',
  subscribe: 'Adherirse'
});

i18next.addResources('es', 'EdenAccounts', {
  relatedSuppliesInformation:
    'Contás con suministros relacionados pendientes de asociar. En caso de querer enlazarlos, podrás hacerlo desde el botón Asociar',
  associate: 'Asociar',
  relatedAccounts: 'SUMINISTROS RELACIONADOS',
  address: 'DIRECCIÓN',
  accounts: 'Mis suministros',
  addAccount: 'Añadir suministro',
  clientNumber: 'NIS',
  clientNumberInput: 'Ingresá tu NIS',
  clientNumberPlaceholder: 'Ingresá tu NIS',
  clientN: 'N° de suministro',
  selectAccounts: 'SELECCIONAR CUENTAS',
  holderName: 'NOMBRE DEL TITULAR',
  add: 'Añadir',
  next: 'Siguiente',
  createAccountMessage: '',
  accountRequired: 'Campo obligatorio',
  wrongAnswers: 'Las respuestas seleccionadas son incorrectas.',
  lengthValidation: 'El NIS debe ser de {{count}} caracteres',
  accountRegistered: 'Ya registraste ese número de suministro',
  accountRelationship: 'Relación con suministro',
  mainCustomer: 'Usuario principal',
  secondaryCustomer: 'Usuario secundario',
  accountRegisterError: 'No se pudo registrar tu suministro en este momento. Por favor intentá más tarde.',
  deleteAccountSuccess: 'El suministro fue desvinculado exitosamente.',
  deleteAccountError: 'El suministro no pudo desvincularse en este momento, por favor intentá más tarde.',
  accountRegisterSuccess: 'El suministro fue registrado exitosamente.',
  getQuestionsError: 'Hubo un problema al solicitar la información.',
  deleteAccount: 'Desvincular suministro',
  deleteAccountConfirmation: '¿Está seguro que desea desvincular este suministro?',
  tooltip:
    'El NIS es el número de identificación de suministro que se encuentra en el margen superior izquierdo de tu factura. Para más información ingresá en nuestra web [www.edensa.com.ar/usuarios/factura/](https://www.edensa.com.ar/usuarios/factura/)'
});

i18next.addResources('es', 'EdenAccountStatus', {
  // General
  direction: 'Dirección',
  clientNumber: 'Número de suministro',
  since: 'hasta',

  // Account
  account: 'Mi suministro',
  myAccounts: 'Mis suministros',
  adheredService: 'ADHERIDO',
  notAdheredService: 'No Adherido',
  adherenceInProgress: 'Adhesión en curso',
  digitalBill: 'Factura digital',
  automaticDebit: 'Débito automático',
  type: 'Tarifa',
  T1: 'Pequeña Demanda',
  T1R: 'Residencial',
  T1S: 'Tarifa Social',
  T1G: 'General',
  T2: 'Mediana Demanda',
  T3: 'Grandes Demandas',
  T5: 'Peaje',
  adhere: '¡ADHERITE!',

  // Account Status
  accountStatus: 'Estado de cuenta',
  amountToPay: 'Importe a pagar',
  payNow: 'Pagar ahora',
  paymentDocument: 'Cupón de pago',
  periodDetail: 'Detalles del período {{period}}',
  filterPlaceholder: 'Ingresá NIS o dirección',

  // Last Bill
  lastBill: 'Mi última factura',
  period: 'Período',
  dateOfIssue: 'Fecha de emisión',
  periodStartedOn: 'Fecha Desde {{startDate}}',
  periodEndedOn: 'Fecha Hasta',
  consumption: 'Consumo',
  amount: 'Importe',
  downloadBill: 'Descargar',
  surchargeAmount: 'Importe',
  dueDate: 'Fecha de vencimiento',

  // Consumption Comparison
  consumptionComparison: 'Mis consumos',
  yourAnualProgress: 'Tu progreso anual',
  efficientMessage:
    '¡Felicitaciones! Ahorraste un {{saving}}% y eso produjo un impacto positivo en el medio ambiente.',
  noEfficientMessage:
    'Tu consumo aumentó un {{saving}}%. Consultá el asesor energético y obtené valiosos tips para poder mejorar.',
  noConsumptionMessage:
    'No contás con consumo registrado para el año anterior. Consultá el asesor energético y obtené valiosos tips. ¡Empezá a ahorrar hoy!',

  // Graphics
  consumptionOnPeak: 'Punta',
  consumptionOffPeak: 'Fuera de punta',
  consumptionRemainder: 'Resto',
  consumptionValley: 'Valle',
  powerBilledOnPeak: 'Punta',
  powerBilledOffPeak: 'Fuera de punta',
  billedPower: 'Potencia',
  energy: 'Energía',

  // Error Message
  noAccounts: 'Debe tener cuentas asociadas para poder realizar esta accion.',
  noBillsAssociatedError: 'Todavía no hay facturas asociadas a tu suministro',
  claimsRestricted:
    'Esta transacción se encuentra restringida debido a su estado de cuenta, por problemas en la vía pública puede avisar en forma anónima y gratuita a través de nuestro Centro de Atención Telefónica 0800 222 3335, todos los días las 24 horas, o dirigirse personalmente a nuestras oficinas comerciales de lunes a viernes de 8 a 14:30 horas.',
  restricted: 'Esta transacción se encuentra restringida debido a tu estado de cuenta actual.',

  // Anual progress
  calcExplanationOne:
    'El cálculo de los consumos acumulados se basa en el consumo acumulado hasta el período actual, tanto para el año actual como para el año anterior.',
  calcExplanationTwo: 'En este caso, el consumo acumulado se calcula hasta Mayo de ambos años, resultando:'
});

i18next.addResources('es', 'EdenBill', {
  issued_on: 'Emisión',
  consumption: 'Consumo',
  period: 'Período consumo',
  document_number: 'Nº de liquidación',
  second_expiration_on: 'Fecha 2do Vto.',
  second_expiration_amount: 'Importe 2do Vto.',
  couponErrorMessage: 'Hubo un error al recuperar el cupón de pago, por favor intentá nuevamente más tarde.',
  loadingBill: 'Estamos recuperando tu factura...',
  detail: 'Detalle de factura'
});

i18next.addResources('es', 'EdenBills', {
  pay: 'Pagar!',
  list: 'Mis facturas',
  period: 'Período',
  expiration: 'Vencimiento',
  amount: 'Importe',
  bill: 'Factura',
  documentType: 'Tipo de factura',
  docTypeInvoice: 'Factura',
  balance: 'Importe',
  nis: 'NIS',
  confirmDownloadMssg: '¿Está seguro que desea confirmar la descarga?',
  confirmDownload: 'Confirmar descarga',
  download: 'Descargar',
  multipleDownload: 'Descargar todas',
  multipleBillsTitle: 'Descargá tus facturas',
  multipleBillsLoading: 'Estamos recuperando tus facturas..',
  payTitle: 'Pagar',
  barcode: 'Código de barras',
  externalId: 'Ref. de pago'
});

i18next.addResources('es', 'EdenClaims', {
  number: 'Número',
  initDate: 'Fecha de inicio',
  formNumber: 'Nro. de reclamo',
  type: 'Tipo',
  actions: 'Acciones',
  locationOutOfBoundaries: 'La dirección se encuentra fuera del area de concesión.',
  askCancelAction: '¿Está seguro de cancelar el reclamo?',
  askReiterationAction: 'Esta seguro de reiterar el reclamo?'
});

i18next.addResources('es', 'EdenClientSummary', {
  clientSummary: 'Resumen de usuario',
  selectText: 'Seleccionar',
  paymText: 'Pagar',
  payAnotherAcc: 'Pagar otros suministros',
  totalAmountText: 'Saldo total del usuario',
  secondaryTopbarText: 'Usuario',
  nis: 'NIS',
  rate: 'Tarifa',
  status: 'Estado',
  balance: 'Saldo pendiente',
  arrow: 'Cuenta asignada'
});

i18next.addResources('es', 'EdenComplaints', {
  complaints: 'Denuncias de conexiones clandestinas',
  crimeComplaintButton: 'Completá el formulario',
  crimeComplaint: 'Hacé tu denuncia completando el siguiente formulario',
  crimeComplaintSubtitle:
    'Complete el siguiente formulario para enviar un informe. Cualquier información proporcionada será mantenida confidencial.',
  crimeComplaintAlert:
    'Si sospecha que se está cometiendo un delito distinto del robo de energía, consulte a la policia local.',
  complaintSubtitle: '',
  contactTitle: 'Hacé tu denuncia por los siguientes canales',
  contactSubtitle: '',
  contactItem1: 'Envie un formulario online',
  contactItem2: 'Llamar al {{complaintsPhone}}',
  contactItem3: 'Enviar mail a {{complaintsMail}}',
  initDate: 'Fecha de inicio',
  atentionHours: 'De lunes a viernes de 8 a 18 hs.'
});

i18next.addResources('es', 'EdenTips', {
  title: 'Título',
  icon: 'icono'
});

i18next.addResources('es', 'EdenAssessor', {
  title: 'Tips para hacer un uso seguro y eficiente de la energía',
  subtitle: '',
  energyAdvisor: 'Consejos'
});

i18next.addResources('es', 'EdenPayments', {
  amount: 'Importe a pagar',
  checkingAccount: 'Estamos verificando su deuda...',
  totalAmount: 'Total deuda seleccionada',
  totalConditionalAmount: 'Total deuda',
  paymentDocument: 'Cupón de pago',
  payOnline: 'Pagar online',
  nis: 'NIS',
  send: 'Pagar',
  selectCard: 'Seleccione la tarjeta con la que desea pagar',
  modalTitle: 'Pagar deuda',
  requireDataInput: 'Ingresá los datos de la tarjeta',
  cardNumber: 'N° de tarjeta',
  securityCode: 'Código de seguridad',
  expirationMonth: 'Mes de vencimiento',
  expirationYear: 'Año de vencimiento',
  name: 'Titular de la tarjeta',
  email: 'Correo electrónico',
  docNumber: 'Numero de documento',
  cardRequired: 'Campo obligatorio',
  codeRequired: 'Campo obligatorio',
  monthRequired: 'Campo obligatorio',
  yearRequired: 'Campo obligatorio',
  nameRequired: 'Campo obligatorio',
  emailRequired: 'Campo obligatorio',
  docNumberRequired: 'Campo obligatorio',
  sixteenDigitsValidation: 'El número debe ser de 16 caracteres',
  threeDigitsValidation: 'El código debe tener 3 caracteres',
  monthValidation: 'Ingresá un mes valido.',
  yearValidation: 'Ingresá un año valido.',
  emailValidation: 'Formato de correo electronico inválido',
  paymentDocDownloadInProgress: 'Estamos descargando tu cupón de pago',
  accountWithoutDebt: 'El suministro no registra liquidaciones emitidas pendientes de pago.',
  downloadPaymentDocument: 'Descargar cupón',
  download: 'Descargar',
  downloadAll: 'Descargar todos',
  paymentDocumentLoading: 'Estamos recuperando tu cupón de pago...',
  multiplePaymentDocumentsLoading: 'Estamos recuperando tus cupones de pago...',
  payZeroError: 'El importe a procesar debe ser mayor a cero.',
  maxAmountThreshold: `Atención: El importe a pagar excede el máximo permitido de {{amount}}.`,
  maxDocsThreshold: `Atención: La cantidad de documentos a pagar excede el máximo permitido de {{docs}}.`,
  cardType: 'Tipo de tarjeta',
  debitCard: 'Tarjeta de débito',
  creditCard: 'Tarjeta de crédito',
  paymentResultSuccess:
    'Tu pago fue realizado con éxito. A la brevedad recibirás un mail con el comprobante. Si tu saldo no ha sido actualizado, aguarda un momento e intenta nuevamente. ¡Muchas gracias!',
  paymentResultFailure:
    'El pago no pudo realizarse. Por favor comunícate con la entidad emisora de tu tarjeta para solucionarlo. ¡Muchas gracias!',
  notInformed: 'No informado',
  paymentDocumentModalTitle: 'Confirmar descarga',
  paymentDocumentModalContent: '¿Desea descargar un cupón de pago por el total de la deuda del suministro?',
  paymentDocumentFile: 'Cupon_pago_{{date}}.pdf',
  paymentDocumentPDF: `Cupon_De_Pago{{date}}.pdf`,
  multiplePaymentDocumentsZip: `Cupones_De_Pago{{date}}.zip`
});

i18next.addResources('es', 'EdenPoints', {
  pointsSummary: 'Tu resúmen de puntos',
  exchange: 'Canjear',
  accumulated: 'Total de tus puntos acumulados',
  iconAltText: 'Puntos!',
  periodPoints: 'Tus puntos ganados en el último período',
  trophyAltText: 'Trofeo',
  pointsTransactionHistory: 'Historial de transacciones',
  period: 'Período',
  category: 'Categoría',
  points: 'Puntos',
  balance: 'Balance',
  automatic_debit: 'Débito Automático',
  digital_bill: 'Factura digital',
  voucher_exchange: 'Canje de puntos',
  pointsHistory: 'VER HISTORIAL COMPLETO',
  pointsHistoryMobile: 'Ver historial de transacciones',
  lastTransactions: 'Últimas transacciones',
  rewardsProgramTitle: 'Programa de Recompensas Utility CO!',
  rewardsProgram: 'Acumulá puntos por tus interacciones digitales y accede a beneficios',
  noMainCustomer: 'Aún no tenés suministros asociados que sumen puntos',
  noTransactions: 'Todavía no tenés transacciones'
});

i18next.addResources('es', 'EdenProcedures', {
  number: 'Número',
  initDate: 'Fecha de inicio',
  formNumber: 'Nro. de trámite',
  formType: 'Tipo de '
});

i18next.addResources('es', 'EdenSocialRate', {
  socialRateQuery: 'Tarifa Social',
  requirementsTitle: 'Criterios para la determinación de la tarifa social',
  requirementsSubtitle: '',
  queryButton: 'Consultar por NIS',
  excludeTitle: 'Criterios de exclusión del beneficio',
  formTitle:
    'Ingresá tu número de NIS para corroborar si cumplís los requisitos estipulados por la organización Sintys para acceder a la Tarifa Social',
  formSelectorTitle: 'Seleccioná el NIS sobre el que deseas realizar la consulta',
  formPlaceholder: 'Ingresá tu NIS',
  formSelectorPlaceholder: 'Domicilio a consultar',
  query: 'Consultar',
  queryInProgress: 'Consultando',
  accountNotExists: 'El suministro ingresado es incorrecto.',
  tooltip:
    'El NIS es el número de identificación de suministro que se encuentra en el margen superior izquierdo de tu factura. Para más información ingresá en nuestra web [www.edensa.com.ar/usuarios/factura/](https://www.edensa.com.ar/usuarios/factura/)'
});

i18next.addResources('es', 'EdenChangeDueDate', {
  topTitle: 'Jubilados y pensionados'
});

i18next.addResources('es', 'EdenVouchers', {
  vouchersExchange: 'Canjear Puntos',
  exchange: 'Canjear',
  arrowLeft: 'Volver',
  points: 'PUNTOS',
  icon: 'icon',
  exchangeConfirmation: '¿Está seguro que desea canjear este voucher por {{points}} puntos?',
  confirm: 'Confirmar',
  exchangeVoucher: 'Canjear voucher',
  deletedVoucher: 'Este voucher ha sido eliminado.',
  expiredVoucher: 'Este voucher ha expirado.',
  alreadyUsedVoucher: 'Este voucher ya ha sido utilizado.',
  insufficientPoints: 'No tenés puntos suficientes.',
  exchanging: 'Canjeando',
  exchangeSucessful: 'El canje se realizó correctamente'
});

i18next.addResources('es', 'EdenPublicBalanceQuery', {
  balanceQueryTitle: 'Saldo deudor',
  balanceQueryDescription:
    'Consultá el saldo de tu suministro al día de la fecha. Incluye facturas no vencidas.',
  query: 'Consultar',
  resultModalTitle: 'Consulta de saldo'
});

i18next.addResources('es', 'EdenPublicLastBill', {
  lastBillTitle: 'Importe y vencimiento de tu última factura',
  lastBillDescription: 'Consultá el importe y vencimiento de tu última factura emitida al día de la fecha.',
  query: 'Consultar',
  resultModalTitle: 'Consulta de ultima factura',
  lastBillQueryError:
    'Hubo un error al recuperar la información de tu última factura, por favor reintentá más tarde.'
});

i18next.addResources('es', 'EdenPublicPayment', {
  getCoupon: 'Obtener cupón de pago',
  accountNumber: 'Número de suministro',
  accountNumberPlaceholder: 'Ingresá tu NIS',
  accountNumberLabel: 'Ingresá tu NIS',
  authorizedPlaces: 'Lugares de pago habilitados',
  neighbourPlaces: 'Acerquese a los lugares de pago con sede en su barrio',
  payOnline: 'Pague online desde la comodidad de su casa',
  accountNumberRequired: 'Campo obligatorio',
  publicPaymentTitle: 'Pago de facturas',
  publicPaymentDocumentTitle: 'Cupón de pago - Factura de Energía',
  publicPaymentByNisTitle: 'Pagá tus facturas',
  publicPaymentByNisSubtitle:
    'Ingresá tu NIS para recuperar tu deuda y poder pagar online con tarjeta de débito o crédito',
  searchPayments: 'Continuar',
  publicPaymentSubtitle:
    'Aquí podrá pagar todas sus facturas vigentes o vencidas, abonar las facturas con aviso de suspensión y pagar la deuda del servicio suspendido, con Tarjeta de Débito Visa, o de Crédito Visa, MasterCard o Nativa. Además podrá consultar toda su deuda, con aviso de suspensión o con servicio suspendido y abonaría través de los locales Provincia Net solo informando el Número de Identificación de Suministro (NIS).',
  publicPaymentDocumentSubtitle:
    'Descargá tu cupón de pago junto con la factura para abonar en cualquier medio de pago habilitado o registrate y pagá online con tarjeta de débito o crédito donde también contarás con múltiples beneficios. <br/> <br/> * Sólo se encontrarán disponibles las facturas emitidas a partir del 9 de marzo',
  onlinePlacesTitle:
    'Si posee tarjeta de crédito o débito puede usar el código de pago electrónico que figura en el cupón en:',
  placesTitle:
    'Si posee tarjeta de crédito o débito puede usar el código de pago electrónico que figura en el cupón en:',
  tooltip:
    'El NIS es el número de identificación de suministro que se encuentra en el margen superior izquierdo de tu factura. Para más información ingresá en nuestra web [www.edensa.com.ar/usuarios/factura/](https://www.edensa.com.ar/usuarios/factura/)'
});

i18next.addResources('es', 'EdenSignin', {
  welcomeTo: 'Bienvenido a',
  password: 'Contraseña',
  forgotPassword: 'Olvidé mi contraseña',
  signIn: 'Iniciar Sesión',
  login: '¡Hola! Ingresá tu usuario y contraseña',
  loginMobile: 'Bienvenido a la Sucursal Virtual',
  noAccount: 'No tengo cuenta',
  register: 'registrarme',

  // TODO: check why these messages are declared here and not in a generic handler
  joinToVirtualOffice: 'Oficina virtual',
  loading: 'Cargando',
  continueWithoutRegistering: 'Continuar sin registrarme',

  // Password Recovery
  recoverPassword: 'Recuperar contraseña',
  recoveryStepsEmail:
    'Ingresá el email que utilizaste para registrarte y te enviaremos las instrucciones para recuperar tu contraseña.',
  recoveryStepsDocType:
    'Ingresá el tipo y número de documento que utilizaste para registrarte y te enviaremos un email con las instrucciones para recuperar tu contraseña.',
  sendRequest: 'ENVIAR SOLICITUD',
  invalidUser: 'Usuario inválido',

  // Change Password
  changePassword: 'Cambiá tu contraseña',
  changePasswordAction: 'Cambiar mi contraseña',
  newPassword: 'Nueva contraseña',
  newPasswordConfirmation: 'Confirmá tu nueva contraseña',

  // Document types
  dni: 'DNI',
  cuit: 'CUIT',
  cip: 'CI provincial',
  cdi: 'Cédula de identidad',
  lc: 'Libreta cívica',
  le: 'Libreta de enrolamiento',
  cdt: 'Certificado de documento en trámite',
  other: 'Otros',
  passport: 'Pasaporte',
  numberInput: 'Número de documento',

  // Validations
  documentTypePlaceholder: 'Seleccione el tipo de documento',
  documentTypeRequired: 'Campo obligatorio',
  emailRequired: 'Campo obligatorio',
  emailFormat: 'El email no tiene un formato válido',
  docNumberRequired: 'Campo obligatorio',
  dniFormat: 'El DNI ingresado no tiene un formato válido',
  cuitFormat: 'El CUIT ingresado no tiene un formato válido',
  otherFormat: 'El número de documento ingresado no tiene un formato válido',
  cipFormat: 'El CI Provincial ingresado no tiene un formato válido',
  cdiFormat: 'La Cédula de identidad ingresada no tiene un formato válido',
  leFormat: 'La Libreta de enrolamiento ingresada no tiene un formato válido',
  passportFormat: 'El Pasaporte ingresado no tiene un formato válido',
  lcFormat: 'La Libreta cívica ingresada no tiene un formato válido'
});

i18next.addResources('es', 'EdenSignUpProgress', {
  action1: 'Ingresá',
  item1: 'tus datos',
  action2: 'Respondé',
  item2: 'las preguntas',
  action3: 'Registrá',
  item3: 'tu usuario',
  action4: 'Validá',
  item4: 'tu email',
  action5: 'Ingresá',
  item5: 'tu suministro',
  action6: 'Validá',
  item6: 'tu relación',
  action7: 'Seleccioná',
  item7: 'tus suministros',
  action8: 'Terminá',
  item8: 'el registro'
});

i18next.addResources('es', 'EdenSignup', {
  documentNumberPlaceholder: 'Número de documento',
  documentTypePlaceholder: 'Seleccione el tipo de documento',
  password: 'Contraseña',
  termsAndConditions: 'Al registrarte aceptás los términos y condiciones',
  signUp: 'Registrarme',
  returnToSignIn: 'Volver al inicio de sesión',
  emailInUse: 'El email ya está siendo utilizado por otro usuario.',
  nameMaxLength: 'El nombre tiene que tener menos de 20 caracteres',
  lastNameMaxLength: 'El apellido tiene que tener menos de 20 caracteres',
  passwordRequired: 'Campo obligatorio',
  passwordMinLength: 'La contraseña debe tener mínimo {{minLength}} caracteres',
  passwordMaxLength: 'El largo máximo de la contraseña es de {{maxLength}} caracteres',
  passwordExactLength: 'La contraseña debe tener {{exactLength}} caracteres',
  emailRequired: 'Campo obligatorio',
  emailFormat: 'El email no tiene un formato válido',
  documentType: 'Tipo de documento',
  documentNumber: 'Número de documento',
  gender: 'Género',
  genderPlaceholder: 'Seleccione su género',
  name: 'Nombre',
  lastName: 'Apellido',
  bornDate: 'Fecha de nacimiento',
  bornDatePlaceholder: 'DD/MM/AAAA',
  carrier: 'Compañía de celular',
  carrierPlaceholder: 'Seleccione la compañía de celular',
  cellNumber: 'Celular',
  cellNumberPlaceholder: 'Nro. de celular (sin 15)',
  phone: 'Teléfono',
  phonePlaceholder: 'Teléfono fijo',
  next: 'Siguiente',
  clientNumber: 'Número de suministro',
  registerAccount: '¡Registrá tu suministro para comenzar!',
  submit: 'Añadir suministro',
  wrongAnswers: 'Las respuestas son incorrectas',
  accountNumber: 'NIS',
  maxDateError: 'Para registrarse debe tener más de 18 años',
  minDateError: 'Fecha de nacimiento inválida',
  male: 'Masculino',
  female: 'Femenino',
  contactName: 'Nombre de contacto',
  contactNamePlaceholder: 'Ingresá el nombre de contacto',
  contactLastName: 'Apellido de contacto',
  contactLastNamePlaceholder: 'Ingresá el apellido de contacto',
  onePhoneNeeded: 'Ingresá al menos un teléfono de contacto',
  carrierNeeded: 'Campo obligatorio',
  acceptTermsConditions: 'Acepto los terminos y condiciones',
  accept: 'Acepto',
  completeYourInformation: 'Completá tus datos',
  registerYourEmail: 'Registrá tu email',
  validateEmail: 'Validá tu email',
  addAccount: 'Añadí tu suministro',
  answerQuestions: 'Respondé las preguntas',
  answerValidationQuestions: 'Respondé las preguntas de validación',
  serviceAdherence: 'Adherite a factura digital',
  addYourAccounts: 'Asociá tus suministros',
  acceptTerms: 'Aceptá los terminos y condiciones',
  codeSent:
    'Te enviamos un mail a {{userEmail}} con el código verificador. Si no ves el correo en tu bandeja de entrada, revisá la carpeta de correo no deseado.',
  verificationCode: 'Código verificador',
  missingMail: '¿No te llegó el email?',
  resend: 'Reenviar',
  validateEmail2: 'Validar Email',
  invalidCode: 'Código de verificación incorrecto.',
  alreadyConfirmed: 'Email confirmado. Inicie sesión.',
  notCreated: 'El usuario no pudo ser creado.',
  notConfirmed:
    'Para finalizar el proceso de registración valide su dirección de email ingresando el código que recibió.',
  invalidEmail: 'Email inválido',
  platformDiscovery0: 'Como se enteró de la oficina virtual?',
  platformDiscovery1: 'Por campaña telefónica',
  platformDiscovery2: 'Por mail',
  platformDiscovery3: 'Por web',
  platformDiscovery4: 'Por referido',
  platformDiscovery5: 'Otros'
});

i18next.addResources('es', 'EdenApiErrors', {
  expired: 'La sesión expiró',
  noConnection: 'El servicio no está disponible en este momento. Revise su conexión a internet.'
});

i18next.addResources('es', 'EdenTranslation', {
  iconAlt: 'Icono',
  avatar: 'Avatar',
  check: 'Seleccionado',
  fieldRequired: 'Campo obligatorio',
  yes: 'Si',
  no: 'No',
  enter: 'Ir al inicio'
});

i18next.addResources('es', 'EdenAccountHolderChange', {
  supply: 'NIS',
  supplyAddress: 'Dirección del suministro registrado',
  accountHolderChangeTitle: 'Cambio de titularidad',
  procedureNumber: 'Trámite N° {{procedure}}',
  accountHolderChangeSubtitle:
    'Aquí usted podrá realizar el cambio de la titularidad de un servicio eléctrico existente, por favor complete la información necesaria',
  continue: 'Continuar',
  checkLabel:
    'Declaro haber leído y conocer el Reglamento de Suministro Vigente (para consultar el Reglamento de Suministro Vigente [ingrese aquí](https://oficinavirtual.edelap.com.ar/#/informacionutil))',
  userDataLabel:
    'Los datos ingresados en la presente tendrán carácter de declaración jurada y en cumplimiento a lo indicado en el artículo 6 de la Ley 25326.',
  userDebtCancel:
    'Es necesario que cancele la deuda existente asociada a este suministro para finalizar el tramite.',
  clientDebt: 'Cargos a abonar del suministro {{supply}}',
  ownDebt: 'Cargos a abonar del cliente {{holder}}',
  createProcedure: 'Ingresar solicitud',
  debtDescriptionNisBelongingUser: 'La deuda a abonar incluye la totalidad de las facturas impagas.',
  accountDebtDescription:
    'La deuda a abonar incluye la totalidad de las facturas impagas, el cálculo de consumo a la fecha, y todo otro concepto que se encuentre pendiente (intereses por mora, gastos administrativos, devolución de depósito en garantía u otros conceptos)',
  cancel: 'Cancelar',
  payDebt: 'Pagar deuda',
  procedureHistory: 'Historial del trámite',
  userDebt: 'Deuda total: {{debt}}',
  supplyError:
    'El Suministro ingresado no puede ser trasladado a su titularidad a través de la Oficina Virtual. Por favor comuníquese con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  nextBillCharge: 'Cargos a incluir en su próxima factura',
  wrongAccount: 'Nro de Suministro Inexistente',
  warrantyCharge: 'Depósito en garantía: {{amount}}',
  holderChangePending:
    'Ud. tiene la presente solicitud en curso sobre el suministro seleccionado. En la siguiente pantalla puede visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma.',
  commercialHolderChangeError:
    'Por el momento, un Suministro con destino Comercial no puede ser trasladado a su titularidad a través de la Oficina Virtual. Por favor comuníquese con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  othersHolderChangeError:
    'Por el momento, un Suministro con destino Consorcio, obra y otros no puede ser trasladado a su titularidad a través de la Oficina Virtual. Por favor comuníquese con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  clientNumberInput: 'Ingresá tu NIS'
});

i18next.addResources('es', 'EdenTerminationRequest', {
  supplySelection: 'Selección de suministro',
  cancel: 'Cancelar',
  submit: 'Solicitar baja',
  evaluateTerminationRequest:
    'Ud. tiene la presente solicitud en curso sobre el suministro seleccionado. En la siguiente pantalla puede visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma.',

  terminationRequest: 'Baja de suministro',
  procedurePlaceholder: 'Aquí usted solicitará la baja del servicio eléctrico y el retiro del medidor. '.concat(
    'Si usted en realidad desea transferir el servicio a nombre de un tercero, el futuro titular podrá solicitar por este medio un cambio de titularidad.'
  ),
  debtPlaceholder: 'Recuerde que deberá contar con una Tarjeta de Crédito para poder completar el Trámite.',
  debtCancelPlaceholder:
    'Es necesario que cancele la deuda existente asociada a este suministro para finalizar el tramite.',
  accountIsEmpty: 'Actualmente este trámite no está disponible para ninguna de tus cuentas.'
});

i18next.addResources('es', 'EdenTime', {
  secSingular: 'seg.',
  secPlural: 'seg.',
  minSingular: 'min.',
  minPlural: 'min.',
  hourSingular: 'hora',
  hourPlural: 'horas',
  daySingular: 'día',
  dayPlural: 'días',
  weekSingular: 'semana',
  weekPlural: 'semanas',
  monthSingular: 'mes',
  monthPlural: 'meses',
  yearSingular: 'año',
  yearPlural: 'años'
});

i18next.addResources('es', 'EdenChangeDueDate', {
  title: 'Cambio de Fecha Vencimiento de Factura',
  startDay: 'Día desde',
  endDay: 'Día hasta',
  sliderHelp: 'Mueva los circulos para elegir el intervalo de fechas.',
  evaluateChangeDueDateError:
    'Hubo un error al recuperar la información de sus fechas de vencimiento actuales, por favor intente nuevamente más tarde.',
  changeDueDateError:
    'Hubo un error al actualizar su fecha de vencimiento. Por favor intente nuevamente más tarde.',
  changeDueDateSuccess: 'La fecha de vencimiento fue actualizada exitosamente.'
});

i18next.addResources('es', 'EdenHome', {
  subtitle: 'Registrate y disfrutá los beneficios que la Sucursal Virtual EDEN tiene para vos.',
  register: 'Registrarme'
});

i18next.addResources('es', 'EdenLanding', {
  action1: 'Pagá tu factura online',
  action2: 'Chequeá tus consumos',
  action3: 'Realizá trámites comerciales',
  action4: 'Descubrí como ahorrar energía',
  title1: 'BIENVENIDO A LA',
  title2: 'SUCURSAL VIRTUAL DE EDEN',
  subtitle: '¡Realizá tus trámites de manera rápida y sencilla!',
  bottomMessage: 'Ponemos la energía en vos',
  socialNetworks: '¡Seguinos en las Redes!'
});

i18next.addResources('es', 'EdenBanner', {
  register: 'Registrarme',
  banner1: '¡Registrate',
  banner2: ' y pagá tus facturas online!',
  banner3: 'servicio disponible las 24 hs.',
  banner4: ''
});

i18next.addResources('es', 'EdenCreditCard', {
  yourName: 'Titular de la tarjeta',
  cardNumber: 'Número de tarjeta',
  holderName: 'Titular de la tarjeta',
  expiry: 'Vencimiento',
  cvc: 'Código seguridad',
  expDate: 'Vencimiento'
});

i18next.addResources('es', 'EdenAppDownloader', {
  downloadAppMobile1: 'Descargá ',
  downloadAppMobile2: 'eden ',
  downloadAppMobile3: 'Móvil',
  downloadAppMobile4: 'Y lleva la ',
  downloadAppMobile5: 'energía ',
  downloadAppMobile6: 'con vos'
});

i18next.addResources('es', 'EdenMaintenance', {
  maintenanceMessage:
    '¡Hola! Nos encontramos realizando tareas de mantenimiento para brindarte un mejor servicio. Para realizar un reclamo, podés comunicarte al 0800-999-3336. ¡Gracias!',
  networkError: 'Hubo un error de red. Por favor verificá tu conexión a Internet.'
});

i18next.addResources('es', 'EdelapEntitiesComplaint', {
  loginTitle: 'Ingrese su usuario para acceder al formulario de denuncias',
  username: 'Usuario',
  enter: 'Ingresar'
});
